import { defineComponent, useTemplateRef, ref, useModel, onMounted, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, unref, Fragment, renderList, withCtx, createTextVNode, toDisplayString, withDirectives, vShow, mergeModels, toRaw } from 'vue';
import { More } from '@element-plus/icons-vue';
import { EditorStorageService } from '@ssml-editor/core';
import { ListWrapper, SelectList } from '@ssml-editor/vue';
import { ElButton, ElTag } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                             */
import BgmContainer from './bgm-container.js';
import { SpeakContentData } from './data.js';
import EffectValueContainer from './effect-value-container.js';
import { generateSpeakUsageRecordLabel } from './method.js';
import VolumeContainer from './volume-container.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "speak-content",
  props: /* @__PURE__ */ mergeModels({
    rates: {},
    pitches: {},
    effects: {},
    storedRecordCount: { default: 40 },
    bgmPageSize: {},
    bgmCategoryPageSize: {},
    fetchBgms: { type: Function },
    fetchCategories: { type: Function },
    searchBgms: { type: Function },
    config: {}
  }, {
    "modelValue": {
      default: new SpeakContentData()
    },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["submit"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const storeKey = "speak";
    const bgmContainerRef = useTemplateRef("bgm-container");
    const showAllUsageRecord = ref(false);
    const speakUsageRecords = ref([]);
    const dataListRate = ref([]);
    const dataListPitch = ref([]);
    const dataListEffect = ref([]);
    const speakContentData = useModel(__props, "modelValue");
    const emit = __emit;
    const editorStorageService = new EditorStorageService(__props.config?.databaseName);
    function usageRecordsItemClickHandler(item) {
      speakContentData.value.rate = item.rate;
      speakContentData.value.pitch = item.pitch;
      speakContentData.value.volume = item.volume;
      speakContentData.value.bgmVolume = item.bgmVolume;
      speakContentData.value.effect = item.effect;
      speakContentData.value.effectValue = item.effectValue;
      speakContentData.value.bgm = item.bgm;
      submitHandler();
    }
    function usageRecordMoreClickHandler() {
      showAllUsageRecord.value = !showAllUsageRecord.value;
    }
    async function readSpeakUsageRecords() {
      return await editorStorageService.read(storeKey) || [];
    }
    async function saveSpeakUsageRecords(speakContentDataList) {
      return await editorStorageService.save(
        storeKey,
        speakContentDataList.slice(0, __props.storedRecordCount)
      );
    }
    async function fetchSpeakUsageRecords() {
      const speakContentDataList = await readSpeakUsageRecords();
      speakUsageRecords.value = speakContentDataList;
    }
    async function pushUsageRecords(label) {
      let speakContentDataList = await readSpeakUsageRecords();
      speakContentDataList = speakContentDataList.filter((speakContentData2) => {
        return speakContentData2.label !== label;
      });
      speakContentDataList.unshift({ ...toRaw(speakContentData.value), label });
      await saveSpeakUsageRecords(speakContentDataList);
      speakUsageRecords.value = speakContentDataList;
    }
    async function deleteUsageRecordsHandler(item) {
      const speakContentDataList = toRaw(speakUsageRecords.value).filter(
        (speakContentData2) => {
          return speakContentData2.label !== item.label;
        }
      );
      await saveSpeakUsageRecords(speakContentDataList);
      speakUsageRecords.value = speakContentDataList;
    }
    async function clearUsageRecordsHandler() {
      await editorStorageService.remove(storeKey);
      speakUsageRecords.value = [];
    }
    async function submitHandler() {
      const data = bgmContainerRef.value?.getData();
      speakContentData.value.bgm = data?.music;
      speakContentData.value.bgmName = data?.musicName;
      const label = generateSpeakUsageRecordLabel(
        dataListRate.value,
        dataListPitch.value,
        speakContentData.value.rate,
        speakContentData.value.pitch,
        speakContentData.value.volume,
        speakContentData.value.effect,
        speakContentData.value.effectValue
      );
      await pushUsageRecords(label);
      emit("submit", { ...toRaw(speakContentData.value), label });
    }
    onMounted(async () => {
      __props.rates && (dataListRate.value = __props.rates);
      __props.pitches && (dataListPitch.value = __props.pitches);
      __props.effects && (dataListEffect.value = __props.effects);
      await fetchSpeakUsageRecords();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["se-speak-content", { "se-usage-record-showed": showAllUsageRecord.value }])
      }, [
        createElementVNode("div", { class: "se-usage-record" }, [
          createVNode(unref(ElButton), {
            size: "small",
            class: "se-usage-record-more",
            icon: unref(More),
            onClick: usageRecordMoreClickHandler
          }, null, 8, ["icon"]),
          createElementVNode("ul", { class: "se-usage-record-list" }, [
            createElementVNode("li", { class: "se-usage-record-list-name" }, "近期使用:"),
            (openBlock(true), createElementBlock(Fragment, null, renderList(speakUsageRecords.value, (item, index) => {
              return openBlock(), createElementBlock("li", {
                onClick: ($event) => usageRecordsItemClickHandler(item),
                key: index
              }, [
                createVNode(unref(ElTag), {
                  type: "info",
                  onClose: ($event) => deleteUsageRecordsHandler(item),
                  closable: ""
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(item.bgmName ? `${item.bgmName}-v${item.bgmVolume} | ${item.label}` : item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["onClose"])
              ], 8, ["onClick"]);
            }), 128))
          ])
        ]),
        withDirectives(createElementVNode("div", { class: "se-speak-content-body" }, [
          createVNode(unref(ListWrapper), { title: "语速" }, {
            default: withCtx(() => [
              createVNode(unref(SelectList), {
                modelValue: speakContentData.value.rate,
                "onUpdate:modelValue": ($event) => speakContentData.value.rate = $event,
                "data-list": dataListRate.value
              }, null, 8, ["modelValue", "onUpdate:modelValue", "data-list"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), { title: "语调" }, {
            default: withCtx(() => [
              createVNode(unref(SelectList), {
                modelValue: speakContentData.value.pitch,
                "onUpdate:modelValue": ($event) => speakContentData.value.pitch = $event,
                "data-list": dataListPitch.value
              }, null, 8, ["modelValue", "onUpdate:modelValue", "data-list"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), {
            title: "音量",
            style: { "width": "5rem" }
          }, {
            default: withCtx(() => [
              createVNode(VolumeContainer, {
                modelValue: speakContentData.value.volume,
                "onUpdate:modelValue": ($event) => speakContentData.value.volume = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), { title: "音效" }, {
            default: withCtx(() => [
              createVNode(unref(SelectList), {
                modelValue: speakContentData.value.effect,
                "onUpdate:modelValue": ($event) => speakContentData.value.effect = $event,
                "data-list": dataListEffect.value
              }, null, 8, ["modelValue", "onUpdate:modelValue", "data-list"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), {
            title: "音效效果",
            style: { "width": "7.5rem" }
          }, {
            default: withCtx(() => [
              createVNode(EffectValueContainer, {
                modelValue: speakContentData.value.effectValue,
                "onUpdate:modelValue": ($event) => speakContentData.value.effectValue = $event,
                effect: speakContentData.value.effect
              }, null, 8, ["modelValue", "onUpdate:modelValue", "effect"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), {
            title: "背景音乐",
            style: { "width": "7.5rem" }
          }, {
            default: withCtx(() => [
              createVNode(BgmContainer, {
                ref: "bgm-container",
                music: speakContentData.value.bgm,
                "music-name": speakContentData.value.bgmName,
                "bgm-category-page-size": __props.bgmCategoryPageSize,
                "bgm-page-size": __props.bgmPageSize,
                "fetch-bgms": __props.fetchBgms,
                "fetch-categories": __props.fetchCategories,
                "search-bgms": __props.searchBgms
              }, null, 8, ["music", "music-name", "bgm-category-page-size", "bgm-page-size", "fetch-bgms", "fetch-categories", "search-bgms"])
            ]),
            _: 1
          }),
          createVNode(unref(ListWrapper), {
            title: "背景音量",
            style: { "width": "5rem" }
          }, {
            default: withCtx(() => [
              createVNode(VolumeContainer, {
                modelValue: speakContentData.value.bgmVolume,
                "onUpdate:modelValue": ($event) => speakContentData.value.bgmVolume = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ], 512), [
          [vShow, !showAllUsageRecord.value]
        ]),
        createElementVNode("div", { class: "se-speak-content-footer" }, [
          withDirectives(createVNode(unref(ElButton), {
            onClick: submitHandler,
            type: "primary"
          }, {
            default: withCtx(() => [
              createTextVNode("确定")
            ]),
            _: 1
          }, 512), [
            [vShow, !showAllUsageRecord.value]
          ]),
          withDirectives(createVNode(unref(ElButton), {
            onClick: clearUsageRecordsHandler,
            type: "primary"
          }, {
            default: withCtx(() => [
              createTextVNode("全部清空")
            ]),
            _: 1
          }, 512), [
            [vShow, showAllUsageRecord.value]
          ])
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=speak-content.vue2.js.map
